export default class ImgZoomController {
	/* @ngInject */
	/**
	 * @param {import('angular').IRootElementService} $element
	 * @param {import('angular').ISCEService} $sce
	 */
	constructor($element, $sce) {
		this.$element = $element;
		this.$sce = $sce;

		/**
		 * @type {number|undefined}
		 */
		this.bx = 0;

		/**
		 * @type {number|undefined}
		 */
		this.by = 0;

		/**
		 * @type {any}
		 */
		this.child = undefined;

		/**
		 * @type {any}
		 */
		this.image = undefined;

		/**
		 * @type {boolean}
		 */
		this.zoomed = false;

		/**
		 * @type {number}
		 */
		this.nw = 0;

		/**
		 * @type {number}
		 */
		this.nh = 0;

		/**
		 * @type {number|undefined}
		 */
		this.rotate = 0;
	}

	/**
	 * @param {MouseEvent} event
	 */
	imageMove(event) {
		if (event) {
			if (!this.init && this.$element !== undefined) {
				// @ts-ignore
				// noinspection JSUnresolvedVariable
				this.nw = this.$element.find('img').get(0).naturalWidth;
				// @ts-ignore
				// noinspection JSUnresolvedVariable
				this.nh = this.$element.find('img').get(0).naturalHeight;
				this.init = true;
			}

			this.bx = (-(event.pageX - this.child.offset().left) * (this.nw - this.child.width())) / this.child.width();
			this.by = (-(event.pageY - this.child.offset().top) * (this.nh - this.child.height())) / this.child.height();

			this.child.css('background-position', `${Math.round(this.bx)}px ${Math.round(this.by)}px`);
		}
	}

	/**
	 * @param {MouseEvent} event
	 */
	toggle(event) {
		this.zoomed = !this.zoomed;

		if (this.zoomed) {
			// if (event) {
			// 	this.imageMove(null, this.image);
			// }
			this.child.css({
				'background-image':    `url(${this.url})`,
			}, undefined);
			this.imageMove(event);
		}
		else {
			this.child.css({
				'background-image':    'none',
			}, undefined);
		}
	}

	/**
	 * @param {any} changes
	 */
	$onChanges(changes) {
		if (changes.rotate) {
			this.$element.css('display', 'none');
			// element.get(0).offsetHeight; // no need to store this anywhere, the reference is enough
			this.$element.css('display', '');
		}
	}

	$onInit() {
		this.init = false;
		this.url = this.image;
		this.child = this.$element.find('> .preview-image > div');
	}
}
